import { Injectable } from '@angular/core';
import { ILookup } from '@max/commercialpermitting/models/commercial-permit-lookup.interface';
import { BaseApiService } from '@max/shared/base-service/base-api.service';
import { Observable } from 'rxjs';
import { AircraftModelModel } from '../models/aircraft-model.model';
import { Airport } from '../models/airport.model';

@Injectable()
export class AircraftLookupService extends BaseApiService {
    constructor() {
        super();
    }

    public getAircraftLookups = (): Observable<any> => this.get('Aircraft/Lookup');

    public getAirportLookups = (): Observable<{ result: Airport[]}> => this.get('Aircraft/Lookup/Airports');

    public getAircraftMakeLookups = (): Observable<any> => this.get('Aircraft/Lookup/Makes');

    public getAircraftModelByMakeLookups = (makeId: number): Observable<any> => this.get(`Aircraft/Lookup/Makes/${makeId}/Models`);

    public addAircraftModel = (aircraftModelModel: AircraftModelModel): Observable<any> => this.post('Aircraft/Lookup/Model/', aircraftModelModel);
}
